throw new Error("File [/worker/nodeWorker.ts] is not to be bundled")